import { useCallback } from "react";
import { LIST_PAGE_LIMIT } from "@/lib/constants";

export function usePagination({
  items,
  fetchMore,
  limit = LIST_PAGE_LIMIT,
  maxLength,
  loadMore = true,
}) {
  const dataLength = items?.data?.length || 0;
  const hasNextPage = items?.pageInfo?.hasNextPage;
  const maxLengthValid = !maxLength || (maxLength && dataLength < maxLength);
  const enableLoadMore = loadMore && hasNextPage && maxLengthValid;

  const fetchMoreCallback = useCallback(async () => {
    if (loadMore && hasNextPage) {
      if (maxLength && dataLength + limit > maxLength) {
        limit = maxLength - dataLength;
      }
      await fetchMore({ variables: { offset: dataLength, limit } });
    }
  }, [loadMore, dataLength, hasNextPage, fetchMore]);

  return { enableLoadMore, fetchMoreCallback };
}
